import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { WorkStation } from '../../models/item/work-station';
import { ApiResponse } from '@card-software/library';

@Injectable({
  providedIn: 'root',
})
export class WorkStationProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/work-station';

  public getAll(): Observable<ApiResponse<WorkStation[]>> {
    return this.httpClient.get<ApiResponse<WorkStation[]>>(`${this.baseUrl}/all`);
  }
}
